import * as types from './types';

export const createSetupIntent = () => {
  return {
    type: types.CREATE_SETUP_INTENT,
  };
};

export const createSetupIntentSuccess = (payload) => {
  return {
    type: types.CREATE_SETUP_INTENT_SUCCESS,
    payload,
  };
};

export const createSetupIntentFail = (payload) => {
  return {
    type: types.CREATE_SETUP_INTENT_FAIL,
    payload,
  };
};

export const attachPaymentMethod = (payload) => {
  return {
    type: types.ATTACH_PAYMENT_METHOD,
    payload,
  };
};

export const attachPaymentMethodSuccess = (payload) => {
  return {
    type: types.ATTACH_PAYMENT_METHOD_SUCCESS,
    payload,
  };
};

export const attachPaymentMethodFail = (payload) => {
  return {
    type: types.ATTACH_PAYMENT_METHOD_FAIL,
    payload,
  };
};

export const getBillingInfo = (payload) => {
  return {
    type: types.GET_BILLING_INFO,
    payload,
  };
};

export const getBillingInfoSuccess = (payload) => {
  return {
    type: types.GET_BILLING_INFO_SUCCESS,
    payload,
  };
};

export const getBillingInfoFail = (payload) => {
  return {
    type: types.GET_BILLING_INFO_FAIL,
    payload,
  };
};

export const getInvoicePreviews = () => {
  return {
    type: types.GET_INVOICE_PREVIEWS,
  };
};

export const addPromoOrReferral = (payload) => {
  return {
    type: types.ADD_PROMO_OR_REFERRAL,
    payload,
  };
};

export const addPromoOrReferralSuccess = (payload) => {
  return {
    type: types.ADD_PROMO_OR_REFERRAL_SUCCESS,
    payload,
  };
};

export const addPromoOrReferralFail = (payload) => {
  return {
    type: types.ADD_PROMO_OR_REFERRAL_FAIL,
    payload,
  };
};

export const setPauseSubscription = (payload) => {
  return {
    type: types.SET_PAUSE_SUBSCRIPTION,
    payload,
  };
};

export const subscribe = (payload) => {
  return {
    type: types.SUBSCRIBE,
    payload,
  };
};

export const pauseSubscription = (payload) => {
  return {
    type: types.PAUSE_SUBSCRIPTION,
    payload,
  };
};

export const renewSubscription = (payload) => {
  return {
    type: types.RENEW_SUBSCRIPTION,
    payload,
  };
};

export const trial = () => {
  return {
    type: types.TRIAL,
  };
};

export const unsubscribe = () => {
  return {
    type: types.UNSUBSCRIBE,
  };
};

export const updateCustomerAddress = (payload) => {
  return {
    type: types.UPDATE_CUSTOMER_ADDRESS,
    payload,
  };
};

export const closeUpdateModal = () => {
  return {
    type: types.CLOSE_UPDATE_MODAL,
  };
};
